import PreviewSection from '../../PreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function TTDetailHTMLPreviewGroupingSection() {}

TTDetailHTMLPreviewGroupingSection.prototype = new PreviewSection();

TTDetailHTMLPreviewGroupingSection.prototype.constructor = TTDetailHTMLPreviewGroupingSection;

TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER = 6;

TTDetailHTMLPreviewGroupingSection.prototype.init = function( notEmptyGroupingLevels, detailCells, joinCommentsByTask, timeFormat, needSwitchToMe){
    PreviewSection.prototype.init.call( this );

    this.notEmptyGroupingLevels = notEmptyGroupingLevels;
    this.detailCells = detailCells;
    this.joinCommentsByTask= joinCommentsByTask;
    this.timeFormat = timeFormat;
    this.needSwitchToMe = needSwitchToMe

    return this;
};

TTDetailHTMLPreviewGroupingSection.prototype.addRows = function( tBody) {
    let currentRowsNumber = 0
    for ( let i = 0; i < this.notEmptyGroupingLevels.length; i++ )
    {
        const groupingLevel = this.notEmptyGroupingLevels[i]
        let levelPreviewName
        if (groupingLevel === ReportGroupingLevel.USER && this.needSwitchToMe) {
            levelPreviewName = this.message("report.common.me")
        } else {
            levelPreviewName = ReportPreviewUtils.getLevelPreviewName(groupingLevel)
        }

        this.addRow(tBody, this._createDataLevelRow(i, levelPreviewName))
        currentRowsNumber++;
    }
    this.addRow(tBody, this._createDataRow());
    currentRowsNumber++;

    if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.detailCells[0], this.notEmptyGroupingLevels) && !this.needSwitchToMe)
    {
        while ( currentRowsNumber < TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER)
        {
            this.addRow(tBody, this._createDataRow());
            currentRowsNumber++;
        }
    }
    else
    {
        while (true)
        {
            for( let i = 0; i < this.notEmptyGroupingLevels.length; i++ )
            {
                const groupingLevel = this.notEmptyGroupingLevels[i]
                let levelPreviewName
                if (groupingLevel === ReportGroupingLevel.USER && this.needSwitchToMe) {
                    if (i === 0) continue
                    levelPreviewName = this.message("report.common.me")
                } else {
                    levelPreviewName = ReportPreviewUtils.getLevelPreviewName(groupingLevel)
                }
                this.addRow(tBody, this._createDataLevelRow(i, levelPreviewName))
                currentRowsNumber++;
                if( currentRowsNumber >= TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER )
                    break;
            }
            if( currentRowsNumber >= TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER )
                break;

            this.addRow( tBody, this._createDataRow() );
            currentRowsNumber++;
            if( currentRowsNumber >= TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER )
                break;
        }
    }
};

TTDetailHTMLPreviewGroupingSection.prototype._createDataRow = function() {
    const row = this.createRow("dataRow")

    for (let i = 0; i < this.detailCells.length; i++) {
        // add css classes only for first cell in row, if groupingLevels are present
        let cellClass = null
        if (i === 0 && this.notEmptyGroupingLevels.length !== 0){
            cellClass = "firstDetailsCellAfterGrouping levelsAmount"+this.notEmptyGroupingLevels.length;
        }
        const detailCell = this.detailCells[i]
        const levelPreviewName = detailCell === ReportGroupingLevel.USER && this.needSwitchToMe ?
                                 this.message("report.common.me") :
                                 ReportPreviewUtils.getLevelPreviewName(detailCell)
        this.addCell(row, levelPreviewName, cellClass);
    }

    this.addSpentCell(row);
    this.addCommentsCell(row);

    return row;
};

TTDetailHTMLPreviewGroupingSection.prototype.addCommentsCell = function ( row )  {
    let commentsCellClass = "commentCell"
    if (this.joinCommentsByTask) {
        commentsCellClass += " joined";
        this.addCell(
                row,
                ReportPreviewUtils.checkGroupingLevel(ReportGroupingLevel.USER, this.notEmptyGroupingLevels) ?
                    this.message("reports.comments_report.form.format.comments_joined_by_dates_without_format") :
                    this.message("reports.comments_report.form.format.comments_joined_by_users_without_format"),
                commentsCellClass
        );
    } else {
        this.addCell( row, this.message("report.common.tt_comments"), commentsCellClass );
    }
};

TTDetailHTMLPreviewGroupingSection.prototype.addSpentCell = function ( row ) {
    ReportPreviewUtils.addHTMLTimeValueCell( row, this.timeFormat, "spent" );
};

/**
 *
 * @param position 0 to 2
 * @param groupingLevel
 * @private
 */
TTDetailHTMLPreviewGroupingSection.prototype._createDataLevelRow = function ( position, groupingLevelName ) {
    const row = this.createRow("groupingLevel_" + (position + 1))
    this.addCell(
        row,
        groupingLevelName,
        "groupingLevelName",
        this.detailCells.length
    );
    this.addSpentCell(row);
    ReportPreviewUtils.addEmptyCell(row);
    return row;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/ttdetail/TTDetailHTMLPreviewGroupingSection.js